module.exports = __webpack_public_path__ + "img/book-blue.ecf9399b.svg";